import * as monacoEditor from 'monaco-editor';

import { uriToServiceName } from '../uriToServiceName';

import { getReferencesForPosition } from './getReferencesForPosition';
import { ProviderState } from './providerHelpers';

export function sdlHoverProviderFactory(
  providerStateRef: React.RefObject<ProviderState>,
): monacoEditor.languages.HoverProvider {
  return {
    async provideHover(
      model,
      position,
    ): Promise<null | monacoEditor.languages.Hover> {
      if (!providerStateRef.current) {
        return null;
      }
      const { allSchemas } = providerStateRef.current;
      const references = await getReferencesForPosition(
        model,
        position,
        providerStateRef,
      );

      return (
        references && {
          contents: references.flatMap((reference) => {
            const service = allSchemas[uriToServiceName(reference.uri)];
            const value = service?.model.getValueInRange(reference.range);
            return value ? { value } : [];
          }),
        }
      );
    },
  };
}
